<template>
    <div class="playbook-landing" v-if="canView('playbooks')">
        <div v-show="!if_play_generating">
            <div class="row">
                <div class="col-12 col-md mb-2 px-0">
                    <h3 class="mb-0" v-if="activeTab === 'home'" >Automate your fundraising</h3>
                    <h3 class="mb-0" v-else >Play Catalog</h3>
                </div>

                <div class="col-12 col-md-auto px-0 d-flex justify-content-end">
                    <nav class="navbar navbar-expand secondary-tab-bar">
                        <ul class="navbar-nav">
                            <li class="nav-item" :class="{ 'disabled': disableHomeTab }">
                                <a
                                    class="nav-link d-flex flex-nowrap secondary-tab"
                                    :class="{ 'secondary-tab-active': activeTab === 'home'}"
                                    
                                    @click.prevent="switchTab('home')"
                                ><span>Home</span></a>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link d-flex flex-nowrap secondary-tab"
                                    :class="{ 'secondary-tab-active': activeTab === 'catalog' }"
                                    href="#"
                                    @click.prevent="switchTab('catalog')"
                                ><span>Catalog</span></a>
                            </li>
                        </ul>
                    </nav>
                </div>
                
            </div>

            <div v-if="activeTab === 'home'" class="row mb-5 mt-2">
                <div class="col-12 px-0">
                    <div class="suggested-plays-container">
                        <div class="card play-card">
                            <div class="card-header">
                                <div class="play-image-container">
                                    <img src="/img/images/playbook_card.png" class="play-image" alt="Play image">
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h4>Smart Play</h4>
                                    </div>
                                    <div class="col-12 mb-0">
                                        <p class="small">Need help? Describe your campaign and we'll customize a play to meet your needs.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="d-flex justify-content-between align-items-center">
                                    <button @click="openSmartPlayDiveDeeperModal" class="btn btn-secondary btn-icon-only-sm btn-sm" data-bs-toggle="tooltip" title="Detailed view with extended insights and context">
                                        <img src="/img/icons/avid-icons/deep-dive.svg" class="icon" alt="">
                                    </button>
                                    <div class="play-actions d-flex gap-2">
                                        <button v-if="canEdit('playbooks')" class="btn btn-primary btn-primary-playbook btn-sm px-3" @click="openNeedHelpModal"><img src="/img/icons/avid-icons/edna.svg" class="icon me-1" alt=""> Start</button>
                                        <div v-else data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                            <button class="btn btn-primary btn-primary-playbook btn-sm px-3" disabled><img src="/img/icons/avid-icons/edna.svg" class="icon me-1" alt=""> Start</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(play, play_index) in suggested_plays" :key="play.id" class="card play-card">
                            <div class="card-header">
                                <div class="play-image-container">
                                    <img :src="play.thumbnail_image || '/img/images/suggested-play-img.png'" class="play-image" alt="Play image">
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h4>{{ play.name }}</h4>
                                    </div>
                                    <div class="col-6 mb-0">
                                        <span class="complexity-label">Complexity</span>
                                    </div>
                                    <div class="col-6 mb-0">
                                        <div class="complexity-dots">
                                            <div v-for="level in 5" :key="level" 
                                                class="complexity-dot" 
                                                :class="{ 'active': level <= play.complexity_level }">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 mb-2">
                                        <span class="complexity-label">Runtime</span>
                                    </div>
                                    <div class="col-6 mb-2">
                                        <span class="complexity-label" v-html='getEstimatedTimeToCreate(play)'></span>
                                    </div>
                                </div>
                            </div>
                                
                            <div class="card-footer">
                                <div class="d-flex justify-content-between align-items-center">
                                    <button @click="openPlaybookDescription(play)" class="btn btn-secondary btn-icon-only-sm btn-sm" 
                                    data-bs-toggle="tooltip" title="Detailed view with extended insights and context">
                                        <img src="/img/icons/avid-icons/deep-dive.svg" class="icon" alt="">
                                    </button>

                                    <div class="play-actions d-flex gap-2">
                                        <a v-if="canEdit('playbooks') && play.id === 0 && client && client.url" class="btn btn-primary btn-sm px-4 font-weight-normal" 
                                            :href="'/experiment_treatments/'+ client.url + '/new'">
                                            Start
                                        </a>
                                        <button v-else-if="canEdit('playbooks')" @click="openPlaybookCreation(play)" class="btn btn-primary btn-sm px-4 font-weight-normal">
                                            Start
                                        </button>
                                        <div v-else class="float-end" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                            <button class="btn btn-primary btn-sm px-4 font-weight-normal" :disabled="true">
                                                Start
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mt-4">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12">
                                <div class="playbook-header-controls">
                                    <div class="nav-controls">
                                        <nav class="navbar navbar-expand tertiary-tab-bar">
                                            <ul class="navbar-nav">
                                                <li class="nav-item">
                                                    <a
                                                        class="nav-link d-flex flex-nowrap tertiary-tab"
                                                        :class="{ 'tertiary-tab-active': viewMode === 'grid' }"
                                                        href="#"
                                                        @click.prevent="setViewMode('grid')"
                                                        data-bs-toggle="tooltip"
                                                        title="Grid view"
                                                    >
                                                        <span><img src="/img/icons/avid-icons/grid-view.svg" class="icon" alt=""></span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a
                                                        class="nav-link d-flex flex-nowrap tertiary-tab"
                                                        :class="{ 'tertiary-tab-active': viewMode === 'list' }"
                                                        href="#"
                                                        @click.prevent="setViewMode('list')"
                                                        data-bs-toggle="tooltip"
                                                        title="List view"
                                                    >
                                                        <span><img src="/img/icons/avid-icons/list-view.svg" class="icon" alt=""></span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav>     
                                        
                                        <nav class="navbar navbar-expand py-0">
                                            <div class="container-fluid px-0">
                                                <div class="collapse navbar-collapse justify-content-md-end">
                                                    <ul class="navbar-nav tertiary-tab-bar flex-row flex-wrap gap-2 mb-0 justify-content-start justify-content-md-end">
                                                        <li class="nav-item">
                                                            <a
                                                                class="nav-link d-flex flex-nowrap tertiary-tab"
                                                                :class="{ 'tertiary-tab-active': playStatus === 'active' }"
                                                                href="#"
                                                                @click.prevent="setPlayStatus('active')"
                                                            >
                                                                <span>
                                                                    <img src="/img/icons/avid-icons/active-plays.svg" class="icon me-2" alt="">
                                                                    Active Plays
                                                                </span>
                                                            </a>
                                                        </li>
                                                        <li class="nav-item">
                                                            <a
                                                                class="nav-link d-flex flex-nowrap tertiary-tab"
                                                                :class="{ 'tertiary-tab-active': playStatus === 'draft' }"
                                                                href="#"
                                                                @click.prevent="setPlayStatus('draft')"
                                                            >
                                                                <span>
                                                                    <img src="/img/icons/avid-icons/draft-plays.svg" class="icon me-2" alt="">
                                                                    Draft Plays
                                                                </span>
                                                            </a>
                                                        </li>
                                                        <li class="nav-item">
                                                            <a
                                                                class="nav-link d-flex flex-nowrap tertiary-tab"
                                                                :class="{ 'tertiary-tab-active': playStatus === 'previous' }"
                                                                href="#"
                                                                @click.prevent="setPlayStatus('previous')"
                                                            >
                                                                <span>
                                                                    <img src="/img/icons/avid-icons/previous-plays.svg" class="icon me-2" alt="">
                                                                    Previous Plays
                                                                </span>
                                                            </a>
                                                        </li>
                                                        <li class="nav-item">
                                                            <a
                                                                class="nav-link d-flex flex-nowrap tertiary-tab"
                                                                :class="{ 'tertiary-tab-active': playStatus === 'experiments' }"
                                                                href="#"
                                                                @click.prevent="setPlayStatus('experiments')"
                                                            >
                                                                <span>
                                                                    <img src="/img/icons/avid-icons/experiments.svg" class="icon me-2" alt="">
                                                                    Experiments
                                                                </span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </nav>                                     
                                    </div>

                                    <div class="search-filter-controls">
                                        <div class="position-relative">
                                            <input type="text" placeholder="Search plays..." aria-label="Search plays..." v-model="search_key" @input="handleFilterSelection()" autocomplete="one-time-code" class="search-box form-control me-1 py-2" style="min-width: 250px;">
                                            <i class="fa fa-search search-placeholder-icon" v-if="!search_key"></i>
                                        </div>

                                        <button class="btn btn-secondary me-1 py-0 dropdown-toggle dropdown-toggle-no-btn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                            <img class="icon" src="/img/icons/avid-icons/filter-funnel-01.svg" alt="">Filters <span v-if="activeFilterCount > 0">({{ activeFilterCount }})</span>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary p-3" style="width: 320px;">
                                            <p>Channel:</p>
                                            <accordion-select 
                                                v-model="filters.asset_type" 
                                                :options="all_asset_types" 
                                                @update:modelValue="handleFilterSelection"
                                            ></accordion-select>

                                            <p class="mt-4">Strategic Focus:</p>
                                            <accordion-select 
                                                v-model="filters.strategy" 
                                                :options="all_strategies" 
                                                @update:modelValue="handleFilterSelection"
                                            ></accordion-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Card body with filtered content -->
                    <div class="card-body p-0">
                        <!-- Grid View -->
                        <div v-if="viewMode === 'grid'" class="p-3 mb-3">
                            <play-grid-view :plays="list_shown" :status="playStatus" @copy-play="handleCopyPlay" @play-deleted="handlePlayDeleted" />
                        </div>

                        <!-- List View -->
                        <div v-else-if="viewMode === 'list'" class="p-0 mt-3">
                            <play-table-view :plays="list_shown" :status="playStatus" :sort-key="sort_key" :sort-order="sort_order" @copy-play="handleCopyPlay" @sort-by-key="sortByKey" @play-deleted="handlePlayDeleted" />
                        </div>


                        <!-- Pagination -->
                        <div class="table-border-bottom-0">
                            <div class="table-pagination">
                                <div class="table-pagination--group d-none d-md-flex">
                                    <div class="position-relative">
                                        <select class="form-select" v-model="num_per_page" @change="reloadPagination(filtered_playbook_types)" aria-label="Num Per Page">
                                            <option value="5000">ALL</option>
                                            <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                        </select>
                                        <div class="select-display-text">
                                            Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                        </div>
                                    </div>
                                </div>

                                <div class="table-pagination--group d-none d-lg-flex">
                                    {{ filtered_playbook_types.length ==0 ? '0' : item_interval }} of {{ filtered_playbook_types.length }}
                                </div>

                                <div class="table-pagination--group">
                                    <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click="moveToPrevPage(filtered_playbook_types)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                        <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                    </button>

                                    <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                        <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click="moveToPage(page, filtered_playbook_types)">
                                            {{ page }}
                                        </button>
                                    </div>
                                    <div class="d-flex page-selector" v-else>
                                        <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click="moveToPage(page, filtered_playbook_types)">
                                            {{ page }}
                                        </button>

                                        <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                        ...
                                        </button>
                                        <button v-if="page_index >= 2 && page_index < page_index_array.length -1" class="btn btn-none btn-icon-only-md current-page">
                                            {{ page_index + 1 }}
                                        </button>

                                        <button v-if="page_index < page_index_array.length -2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                        ...
                                        </button>
                                        <button :class="page_index === (page_index_array.length -1) ? 'current-page' : ''" class="btn btn-none btn-icon-only-md" @click="moveToPage(page_index_array.length, filtered_playbook_types)" :key="page_index_array.length">
                                            {{ page_index_array.length }}
                                        </button>
                                    </div>

                                    <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click="moveToNextPage(filtered_playbook_types)" :disabled="page_index === page_count -1" data-bs-toggle="tooltip" title="Next page">
                                        <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="activeTab === 'catalog'" class="row mt-2">
                <playbook-landing-catalog @open-playbook-creation="openPlaybookCreation" @open-need-help="openNeedHelpModal" @open-dive-deeper="openSmartPlayDiveDeeperModal"/>
            </div>            
        </div>
        
        <!-- Loading Screen -->
        <playbook-loading-screen
            v-show="if_play_generating"
            :show="if_play_generating"
            :playbook-url="currentPlaybookUrl"
            :playbook-id="currentPlaybookId"
            :total-assets="currentTotalAssets"
            @navigate="handleLoadingNavigate"
        />

        <!-- Playbook Description Modal -->
        <playbook-type-information-modal 
            v-if="selectedPlaybook"
            :playbook_type="selectedPlaybook"
            :show="showPlaybookDescriptionModal"
            @update:show="showPlaybookDescriptionModal = $event"
        />

        <!-- Playbook Creation Modal -->
        <playbook-creation-modal
            v-show="!if_play_generating"
            :show="showPlaybookCreationModal"
            :playbook_type="selectedPlaybookType"
            @update:show="handlePlaybookCreationModalClose"
            @play-creating="handlePlayGenerating"
            @play-created="handlePlayCreated"
        />

        <!-- Playbook Copy Modal -->
        <playbook-copy-modal 
            v-if="playbookToCopy"
            :original-playbook="playbookToCopy"
            :show="showPlaybookCopyModal"
            @update:show="showPlaybookCopyModal = $event"
            @play-creating="handlePlayGenerating"
            @play-created="handlePlayCreated"
        />

        <!-- Need help? modal -->
        <need-help-playbook-modal
            :show="showNeedHelpModal"
            :initial-description="needHelpRefineDescription"
            @update:show="showNeedHelpModal = $event"
            @submitted="handleNeedHelpSubmitted"
        />

        <!-- Smart Play Dive Deeper modal -->
        <div class="modal fade smart-play-dive-deeper-modal" id="smart-play-dive-deeper-modal" tabindex="-1" aria-labelledby="smart-play-dive-deeper-modal-label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content smart-play-dive-deeper-content">
                    <div class="modal-header border-0 smart-play-dive-deeper-header">
                        <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="modal" @click="closeSmartPlayDiveDeeperModal" aria-label="Close" data-bs-toggle="tooltip" title="Close">
                            <img class="icon" src="/img/icons/avid-icons/close.svg" alt="">
                        </button>
                    </div>
                    <div class="modal-body smart-play-dive-deeper-body px-5">
                        <h3 class="modal-title smart-play-dive-deeper-title mb-2"  id="smart-play-dive-deeper-modal-label">Smart Play</h3>
                        
                        <p class="smart-play-dive-deeper-text">When you're not sure which play to run, Avid can help you choose. Describe your campaign goal, audience, or timing, and Avid will analyze your inputs to recommend the play most likely to drive results. You stay in control while getting a faster path to the right strategy.</p>
                    </div>
                    <div class="modal-footer border-0 smart-play-dive-deeper-footer">
                        <button type="button" class="btn btn-secondary btn-sm px-4" @click="closeSmartPlayDiveDeeperModal">Cancel</button>
                        <button type="button" class="btn btn-primary-playbook btn-primary btn-sm px-4" @click="startFromSmartPlayDiveDeeper">
                            <img src="/img/icons/avid-icons/edna.svg" class="icon me-1" alt=""> Start
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Playbook proposal modal (after need help suggestion) -->
        <playbook-proposal-modal
            v-if="client"
            ref="playbookProposalModalRef"
            :client="client"
            @started="handleProposalStarted"
            @refine-notification-shown="handleRefineNotificationShown"
        />
    </div>
</template>

<script>
    import vSelect from "vue3-select";
    import tablePaginationMixin from '../../mixins/table_pagination';
    import permissionsMixin from '../../mixins/permissions';
    import { usePlaybookStore } from '../../stores/playbook';
    import { useClientStore } from '../../stores/client';
    import PlaybookCreationModal from './PlaybookCreationModal.vue';
    import PlaybookLoadingScreen from './PlaybookLoadingScreen.vue';
    import PlaybookLandingCatalog from './PlaybookLandingCatalog.vue';
    import PlaybookTypeInformationModal from './PlaybookTypeInformationModal.vue';
    import PlaybookCopyModal from './PlaybookCopyModal.vue';
    import NeedHelpPlaybookModal from './NeedHelpPlaybookModal.vue';
    import PlaybookProposalModal from './PlaybookProposalModal.vue';
    import PlayGridView from './PlayGridView.vue';
    import PlayTableView from './PlayTableView.vue';
    import statsigService from '../../services/statsig';
    import { router } from '@inertiajs/vue3';
    import { useNotifications } from '../../composables/useNotifications';
    
    export default {
        components: { 
            vSelect, 
            PlaybookCreationModal, 
            PlaybookLoadingScreen,
            PlaybookLandingCatalog,
            PlaybookTypeInformationModal,
            PlaybookCopyModal,
            NeedHelpPlaybookModal,
            PlaybookProposalModal,
            PlayGridView,
            PlayTableView
        },
        mixins: [tablePaginationMixin, permissionsMixin],

        data() {
            return {
                list_tabs:['Play Catalog'],
                tab_name_active: 'Play Catalog',
                activeTab: this.getInitialActiveTab(),
                disableHomeTab: false,
                suggested_plays: [], // TODO: need to replace this later
                // View and filter controls
                viewMode: 'grid', // grid, list
                playStatus: this.getStoredPlayStatus(), // Load from localStorage

                local_playbook_types: [],
                filtered_playbook_types: [],
                list_shown: [],
                search_key: '',
                sort_key: 'name',
                sort_order: 'asc',
                filtered_my_plays_count: 0,

                // Dropdown search
                dropdownSearchKey: '',
                filteredDropdownItems: [],

                // for filter options
                all_asset_types: [],
                all_strategies: [],
                filters:{
                    asset_type: {
                        category:"",
                        text: "*** All Channels ***",
                        value: -1
                    },
                    strategy: {
                        category: "",
                        text: "*** All Strategic Focuses ***",
                        value: -1
                    },
                },
                isAtStart: true,
                isAtEnd: false,
                activeRecommendationTooltipIndex: -1,
                activeCatalogTooltipIndex: -1,
                expandedDescriptions: [],
                
                // Modal state
                selectedPlaybook: null,
                showPlaybookDescriptionModal: false,
                selectedPlaybookType: null,
                showPlaybookCreationModal: false,
                if_play_generating: false,
                currentPlaybookId: null,
                currentPlaybookUrl: null,
                currentTotalAssets: 0,
                
                // Copy modal state
                playbookToCopy: null,
                showPlaybookCopyModal: false,

                // Need help / suggestion state
                showNeedHelpModal: false,
                needHelpRefineDescription: '',
                showSmartPlayDiveDeeperModal: false,
                needHelpPendingNotificationId: null,
                refinePendingNotificationId: null,

                // Video modal state
                showVideoModal: false,
                videoUrl: 'https://www.youtube.com/embed/YOUR_VIDEO_ID', // Replace YOUR_VIDEO_ID with your actual YouTube video ID
                
                // Playbook data from window
                playbooks: [],
            };
        },
        setup() {
            const playbookStore = usePlaybookStore();
            const clientStore = useClientStore();
            const { removeNotification } = useNotifications();
            return {
                playbookStore,
                clientStore,
                router,
                removeNotification,
            };
        },
        beforeMount() {
            if (window.__CLIENT__) {
                this.clientStore.setClient(window.__CLIENT__);
            }
            if (window.__PLAYBOOK__) {
                this.playbookStore.initialize(window.__PLAYBOOK__);
            }
            this.initializeComponent();

            if(!this.playbooks || this.playbooks.length === 0){
                this.activeTab = 'catalog';
                this.disableHomeTab = true;
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initializeTooltips();
            });
            if (statsigService.getClient()) {
                statsigService.logEvent('playbook_list_viewed', null, {});
            }
            const client = this.clientStore.getClient;
            if (client?.id && window.Echo) {
                window.Echo.private('client.' + client.id).listen('.PlaybookSuggestionReady', (e) => {
                    if (this.needHelpPendingNotificationId != null) {
                        this.removeNotification(this.needHelpPendingNotificationId);
                        this.needHelpPendingNotificationId = null;
                    }
                    if (this.refinePendingNotificationId != null) {
                        this.removeNotification(this.refinePendingNotificationId);
                        this.refinePendingNotificationId = null;
                    }
                    if (e.playbook_suggestion_id && this.$refs.playbookProposalModalRef) {
                        this.$refs.playbookProposalModalRef.show(e.playbook_suggestion_id);
                    }
                });
            }
        },
        updated() {
            this.initializeTooltips();
        },
        computed: {
            client() {
                return this.clientStore.getClient;
            },
            playbook_types() {
                return this.playbookStore.getPlaybookTypes;
            },
            activeFilterCount() {
                let count = 0;
                // Count active filters, excluding text search
                if (this.filters.asset_type && this.filters.asset_type.value !== -1) count++;
                if (this.filters.strategy && this.filters.strategy.value !== -1) count++;
                return count;
            }
        },
        methods: {
            getInitialActiveTab() {
                const params = new URLSearchParams(window.location.search);
                const view = params.get('view');
                if (view === 'catalog') return 'catalog';
                if (view === 'list' || view === 'home') return 'home';
                const stored = localStorage.getItem('playbook_landing_active_tab');
                return stored && ['home', 'catalog'].includes(stored) ? stored : 'home';
            },
            getStoredActiveTab() {
                const stored = localStorage.getItem('playbook_landing_active_tab');
                return stored && ['home', 'catalog'].includes(stored) ? stored : 'home';
            },
            
            getStoredPlayStatus() {
                const stored = localStorage.getItem('playbook_landing_play_status');
                return stored && ['active', 'draft', 'previous', 'experiments'].includes(stored) ? stored : 'draft';
            },
            
            saveActiveTab(tab) {
                localStorage.setItem('playbook_landing_active_tab', tab);
            },
            
            savePlayStatus(status) {
                localStorage.setItem('playbook_landing_play_status', status);
            },
            
            initializeComponent() {
                // Get playbooks from window data or store
                this.playbooks = window.__PLAYBOOK__?.playbooks || this.playbookStore.getPlaybooks || [];

                if (this.playbooks && this.playbooks.length > 0){
                    this.list_tabs = ['My Plays', 'Play Catalog'];
                    this.tab_name_active = 'My Plays';
                    // Apply status filtering to playbooks
                    this.filterPlaybooksByStatus();
                } else {
                    // If no playbooks, process playbook_types as before
                    this.loadLocalPlaybookTypes(this.playbook_types);

                    this.filtered_playbook_types = [...this.local_playbook_types];
                    this.filteredDropdownItems = [...this.local_playbook_types];
                }
                
                this.getSuggestedPlays();
                this.loadFilterOptions();
                this.reloadPagination(this.filtered_playbook_types);
            },
            loadLocalPlaybookTypes(playbook_types){
                this.local_playbook_types = [];

                playbook_types.forEach(playbook_type => {
                    if (playbook_type.id != 0){ // hide experiment treatment from the play catalog list
                        var temp = playbook_type;
                        temp.if_show_all_asset_types = false;
                        temp.unique_asset_types = this.getUniqueAssetTypes(playbook_type.asset_types);
                        temp.complexity_level = this.getComplexityLevel(temp);
                        this.local_playbook_types.push(temp);
                    }
                });

                //Sort the local_playbook_types by name
                this.local_playbook_types.sort((a, b) => a.name.localeCompare(b.name));

                return this.local_playbook_types;
            },
            getSuggestedPlays(){
                // Filter playbook types to only include specific IDs: [29, 30, 27, 28];
                const allowedIds = [14, 15,16, 19];
                const filteredPlays = this.playbook_types.filter(play => 
                    allowedIds.includes(play.id)
                );

                // Ensure they have complexity_level
                this.suggested_plays = filteredPlays.map(play => {
                    if (!play.complexity_level) {
                        play.complexity_level = this.getComplexityLevel(play);
                    }
                    return play;
                });
            },
            loadFilterOptions(){
                // Clear existing arrays
                this.all_strategies = [];
                this.all_asset_types = [];

                // Add "All" options first
                const all_asset_types_option = {
                    category:"",
                    text: "*** All Channels ***",
                    value: -1
                };
                this.all_asset_types.push(all_asset_types_option);

                const all_strategy_option = {
                    category: "",
                    text: "*** All Strategic Focuses ***",
                    value: -1
                };
                this.all_strategies.push(all_strategy_option);

                // Collect Channels from playbook types
                const self = this;
                this.playbook_types.forEach((playbook_type) =>{
                    if (playbook_type.asset_types){
                        playbook_type.asset_types.forEach((asset_type) =>{
                            const asset_type_index = self.all_asset_types.findIndex(a_t=> a_t.id == asset_type.id);
                            if (asset_type_index == -1){
                                asset_type.category = "";
                                asset_type.text = asset_type.name;
                                asset_type.value = asset_type.id;
                                self.all_asset_types.push(asset_type);
                            }
                        });
                    }
                });

                // Sort the arrays (except the first item which is the "All" option)
                const sortedAssetTypes = this.all_asset_types.slice(1).sort((a, b) => a.text.localeCompare(b.text));
                this.all_asset_types = [this.all_asset_types[0], ...sortedAssetTypes];

                // Add strategy options
                const strategies = ["Acquisition","Awareness","Reactivation","Retention","Upgrade"];
                strategies.forEach((strategy, index) =>{
                    const strategy_option = {
                        category: "",
                        text: strategy,
                        value: index+1
                    };
                    this.all_strategies.push(strategy_option);
                });

                // Make sure the default filters are set to "All" options
                this.$nextTick(() => {
                    this.filters.asset_type = all_asset_types_option;
                    this.filters.strategy = all_strategy_option;
                });
            },
            setActiveTab(tab_name){
                this.tab_name_active = tab_name;
            },
            switchTab(tab) {
                this.activeTab = tab;
                this.saveActiveTab(tab);
                this.syncTabToUrl(tab);
            },
            syncTabToUrl(tab) {
                const client = this.clientStore.getClient;
                if (!client?.url) return;
                const path = `/playbooks/${client.url}/list`;
                const url = tab === 'catalog' ? `${path}?view=catalog` : path;
                window.history.replaceState({}, '', url);
            },
            getUniqueAssetTypes(assetTypes) {
                // Create a Map using icon_class as the key to remove duplicates
                const uniqueAssetTypes = new Map(
                    assetTypes.map(asset => [asset.icon_class, asset])
                );
                // Convert Map values back to array
                return Array.from(uniqueAssetTypes.values());
            },
            // getDisplayAssetTypes(assetTypes) {
            //     // Get unique Channels and return only the first 3
            //     const uniqueTypes = this.getUniqueAssetTypes(assetTypes || []);
            //     return uniqueTypes.slice(0, 3);
            // },
            // getRemainingAssetTypesCount(assetTypes) {
            //     // Count how many Channels are not displayed (beyond the first 3)
            //     const uniqueTypes = this.getUniqueAssetTypes(assetTypes || []);
            //     return Math.max(0, uniqueTypes.length - 3);
            // },
            getRemainingAssetTypesNames(assetTypes) {
                // Get names of remaining Channels for tooltip
                const uniqueTypes = assetTypes || [];
                if (uniqueTypes.length <= 3) return '';

                return uniqueTypes.slice(3).map(type => type.name).join(', ');
            },
            handleFilterSelection(){
                let filtered_list = [];
                let self = this;

                this.local_playbook_types.forEach(playbook_type => {
                    let in_search = this.search_key == '' || playbook_type.name.toLowerCase().includes(this.search_key.toLowerCase());

                    if (in_search){
                        let if_match_asset_type = false;
                        let if_match_strategy = false;

                        // Check Channel filter
                        if (self.filters.asset_type) {
                            if (self.filters.asset_type.value === -1) {
                                // All Channels option
                                if_match_asset_type = true;
                            } else if (playbook_type.asset_types && playbook_type.asset_types.length > 0) {
                                // Check if any of the playbook's Channels match the selected Channel
                                if_match_asset_type = playbook_type.asset_types.some(asset_type => 
                                    asset_type && asset_type.id === self.filters.asset_type.value
                                );
                            }
                        } else {
                            if_match_asset_type = true;
                        }

                        // Check strategy filter
                        
                        if (self.filters.strategy) {
                            if (self.filters.strategy.value === -1) {
                                // All Strategic Focuses option
                                if_match_strategy = true;
                            } else if (playbook_type.playbook_type && playbook_type.playbook_type.strategy && playbook_type.playbook_type.strategy.length > 0) {
                                // Find the strategy text from the value
                                const strategyText = self.all_strategies.find(s => s.value === self.filters.strategy.value)?.text;
                                if (strategyText) {
                                    if_match_strategy = playbook_type.playbook_type.strategy.includes(strategyText);
                                }
                            }
                        } else {
                            if_match_strategy = true;
                        }

                        if(if_match_asset_type && if_match_strategy){
                            filtered_list.push(playbook_type);
                        }
                    }
                });

                this.filtered_playbook_types = filtered_list;
                this.sortData();
                this.reloadPagination(this.filtered_playbook_types);
            },
            sortByKey(key) {
                if (this.sort_key === key) {
                    this.sort_order = (this.sort_order === 'asc') ? 'des' : 'asc';
                } else {
                    this.sort_key = key;
                    this.sort_order = 'asc';
                }
                this.sortData();
            },
            sortData() {
                if (this.sort_key === 'name') {
                    if (this.sort_order === 'asc') {
                        this.filtered_playbook_types.sort((a, b) => a.name.localeCompare(b.name));
                    } else {
                        this.filtered_playbook_types.sort((a, b) => b.name.localeCompare(a.name));
                    }
                } else if (this.sort_key === 'playbook_type') {
                    if (this.sort_order === 'asc') {
                        this.filtered_playbook_types.sort((a, b) => {
                            const nameA = a.playbook_type ? a.playbook_type.name : '';
                            const nameB = b.playbook_type ? b.playbook_type.name : '';
                            return nameA.localeCompare(nameB);
                        });
                    } else {
                        this.filtered_playbook_types.sort((a, b) => {
                            const nameA = a.playbook_type ? a.playbook_type.name : '';
                            const nameB = b.playbook_type ? b.playbook_type.name : '';
                            return nameB.localeCompare(nameA);
                        });
                    }
                } else if (this.sort_key === 'created_at') {
                    if (this.sort_order === 'asc') {
                        this.filtered_playbook_types.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                    } else {
                        this.filtered_playbook_types.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    }
                } else if (this.sort_key === 'created_by') {
                    if (this.sort_order === 'asc') {
                        this.filtered_playbook_types.sort((a, b) => {
                            const nameA = a.created_by_user ? (a.created_by_user.first_name + ' ' + (a.created_by_user.last_name || '')) : '';
                            const nameB = b.created_by_user ? (b.created_by_user.first_name + ' ' + (b.created_by_user.last_name || '')) : '';
                            return nameA.localeCompare(nameB);
                        });
                    } else {
                        this.filtered_playbook_types.sort((a, b) => {
                            const nameA = a.created_by_user ? (a.created_by_user.first_name + ' ' + (a.created_by_user.last_name || '')) : '';
                            const nameB = b.created_by_user ? (b.created_by_user.first_name + ' ' + (b.created_by_user.last_name || '')) : '';
                            return nameB.localeCompare(nameA);
                        });
                    }
                }
                this.reloadPagination(this.filtered_playbook_types);
            },
            showAllChannels(index){
                // Simply show the tooltip for the hovered row
                this.activeCatalogTooltipIndex = index;
                // Reset recommendation tooltip
                this.activeRecommendationTooltipIndex = -1;
            },
            hideAllChannels(){
                // Simply hide all catalog tooltips
                this.activeCatalogTooltipIndex = -1;
            },
            showRecommendationChannels(index, event){
                // Just show the tooltip for the hovered element
                this.activeRecommendationTooltipIndex = index;
                // Reset catalog tooltip
                this.activeCatalogTooltipIndex = -1;

                // Wait for the tooltip to be rendered
                this.$nextTick(() => {
                    // Get the tooltip element
                    const tooltip = document.querySelector('.recommendation-tooltip');
                    if (tooltip && event) {
                        // Position the tooltip directly under the mouse cursor
                        const channelsContainer = event.currentTarget;
                        const rect = channelsContainer.getBoundingClientRect();

                        // Calculate position to be directly under the channels
                        tooltip.style.top = (rect.bottom + 10) + 'px';
                        tooltip.style.left = rect.left + 'px';
                        // tooltip.style.width = rect.width + 'px';
                    }
                });
            },
            hideRecommendationChannels(){
                // Simply hide all recommendation tooltips
                this.activeRecommendationTooltipIndex = -1;
            },
            filterDropdownItems() {
                try {
                    if (!this.dropdownSearchKey) {
                        this.filteredDropdownItems = [...this.local_playbook_types];
                    } else {
                        const searchTerm = this.dropdownSearchKey.toLowerCase();
                        this.filteredDropdownItems = this.local_playbook_types.filter(item =>
                            item && item.name && item.name.toLowerCase().includes(searchTerm)
                        );
                    }
                } catch (error) {
                    console.error('Error in filterDropdownItems:', error);
                    this.filteredDropdownItems = [...this.local_playbook_types];
                }
            },
            getTruncatedDescription(play) {
                if (!play.description) return '';
                // Use a fixed length for truncation (approximately 2-3 lines of text)
                const maxLength = 120;
                return play.description.length > maxLength
                    ? play.description.substring(0, play.description.substring(0, maxLength).lastIndexOf(' '))
                    : play.description;
            },

            isDescriptionTruncated(play) {
                // Check if the description is longer than our truncation limit
                return play.description && play.description.length > 120;
            },

            toggleDescription(playId) {
                // Find the index of the play ID in the expandedDescriptions array
                const index = this.expandedDescriptions.indexOf(playId);

                // If the ID is already in the array, remove it (collapse)
                // Otherwise, add it to the array (expand)
                if (index !== -1) {
                    this.expandedDescriptions.splice(index, 1);
                } else {
                    this.expandedDescriptions.push(playId);
                }
            },

            getComplexityLevel(play) {
                const assetTypeCount = play.asset_types ? play.asset_types.length : 0;
                
                if (assetTypeCount < 3) {
                    return 1;
                } else if (assetTypeCount < 5) {
                    return 2;
                } else if (assetTypeCount < 8) {
                    return 3;
                } else if (assetTypeCount < 10) {
                    return 4;
                } else {
                    return 5;
                }
            },

            getEstimatedTimeToCreate(play) {
                if (!play.asset_types || play.asset_types.length === 0) {
                    return 'Unknown';
                }

                // Find the maximum days_before_end_date among all asset types
                let maxDays = 0;
                play.asset_types.forEach(assetType => {
                    if (assetType.pivot && assetType.pivot.days_before_end_date) {
                        const days = parseInt(assetType.pivot.days_before_end_date);
                        if (days > maxDays) {
                            maxDays = days;
                        }
                    }
                });

                if (maxDays === 0) {
                    return '<img src="/img/icons/avid-icons/infinite.svg" class="icon" alt="">';
                }

                // Round to either days or weeks
                if (maxDays >= 7) {
                    const weeks = Math.round(maxDays / 7);
                    return `${weeks} week${weeks > 1 ? 's' : ''}`;
                } else {
                    return `${maxDays} day${maxDays > 1 ? 's' : ''}`;
                }
            },

            initializeTooltips() {
                const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

                for (var i = 0; i < tooltipTriggerList.length; i++) {
                    (function(index) {
                        tooltipTriggerList[index].addEventListener('click', function() {
                            // Hide the tooltip using the index passed to the closure
                            tooltipList[index].hide();
                        });
                        tooltipTriggerList[index].addEventListener('mouseleave', function() {
                            // Hide the tooltip using the index passed to the closure
                            tooltipList[index].hide();
                        });
                    })(i);
                }
            },

            setViewMode(mode) {
                this.viewMode = mode;
                // TODO: Implement view mode logic
            },

            setPlayStatus(status) {
                this.playStatus = status;
                this.savePlayStatus(status);
                this.filterPlaybooksByStatus();
                // Apply current search and filter criteria after status filtering
                this.handleFilterSelection();
            },

            filterPlaybooksByStatus() {
                if (!this.playbooks || this.playbooks.length === 0) {
                    this.local_playbook_types = [];
                    this.filtered_playbook_types = [];
                    this.reloadPagination(this.filtered_playbook_types);
                    return;
                }

                let filteredPlaybooks = [];

                switch (this.playStatus) {
                    case 'active':                        
                        // Get all instances where status is "active"
                        filteredPlaybooks = this.playbooks.filter(playbook => 
                            playbook.status === 'active'
                            //Exclude experiment treatments
                            && !(playbook.playbook_type && playbook.playbook_type.id === 0)
                            && (!playbook.end_date || new Date(playbook.end_date) >= new Date())
                        );
                        break;
                    
                    case 'draft':
                        // Get all instances where status is "draft"
                        filteredPlaybooks = this.playbooks.filter(playbook => 
                            playbook.status != 'active'
                            //Exclude experiment treatments
                            && !(playbook.playbook_type && playbook.playbook_type.id === 0)
                        );
                        break;
                    
                    case 'previous':
                        // Get all instances where status is "archive" or has passed the end_date
                        filteredPlaybooks = this.playbooks.filter(playbook => {
                            //Also exclude experiment treatments
                            return playbook.status === 'active'
                                && !(playbook.playbook_type && playbook.playbook_type.id === 0)
                                && (playbook.end_date && new Date(playbook.end_date) < new Date());
                        });
                        break;
                    
                    case 'experiments':
                        // Get all instances where playbook_type.id === 0
                        filteredPlaybooks = this.playbooks.filter(playbook => 
                            playbook.playbook_type && playbook.playbook_type.id === 0
                        );
                        break;
                    
                    default:
                        // If no specific status is selected, show all playbooks
                        filteredPlaybooks = [...this.playbooks];
                        break;
                }

                // Process the filtered playbooks similar to how we process playbook_types
                this.loadLocalPlaybookTypes(filteredPlaybooks);

                this.filtered_playbook_types = [...this.local_playbook_types];
                this.sortData();
                this.reloadPagination(this.filtered_playbook_types);
            },
            
            openPlaybookDescription(playbook) {
                this.selectedPlaybook = playbook;
                this.showPlaybookDescriptionModal = true;
            },

            openPlaybookCreation(playbook) {
                this.selectedPlaybookType = playbook;
                this.showPlaybookCreationModal = true;
            },

            handlePlayCreated(data) {
                // Set the loading state and playbook information
                this.if_play_generating = true;
                this.currentPlaybookId = data.playbookId;
                this.currentPlaybookUrl = data.playbookUrl;
                this.currentTotalAssets = data.totalAssets || 0;
            },

            openNeedHelpModal() {
                this.needHelpRefineDescription = '';
                this.showNeedHelpModal = true;
                this.$nextTick(() => {
                    const el = document.getElementById('need-help-playbook-modal');
                    if (el && window.bootstrap) {
                        let modal = window.bootstrap.Modal.getInstance(el);
                        if (!modal) modal = new window.bootstrap.Modal(el);
                        modal.show();
                    }
                });
            },

            openSmartPlayDiveDeeperModal() {
                this.showSmartPlayDiveDeeperModal = true;
                this.$nextTick(() => {
                    const el = document.getElementById('smart-play-dive-deeper-modal');
                    if (el && window.bootstrap) {
                        let modal = window.bootstrap.Modal.getInstance(el);
                        if (!modal) modal = new window.bootstrap.Modal(el);
                        modal.show();
                    }
                });
            },

            closeSmartPlayDiveDeeperModal() {
                this.showSmartPlayDiveDeeperModal = false;
                const el = document.getElementById('smart-play-dive-deeper-modal');
                if (el && window.bootstrap) {
                    const modal = window.bootstrap.Modal.getInstance(el);
                    if (modal) modal.hide();
                }
            },

            startFromSmartPlayDiveDeeper() {
                this.closeSmartPlayDiveDeeperModal();
                this.openNeedHelpModal();
            },

            handleNeedHelpSubmitted(payload) {
                if (payload?.notificationId != null) {
                    this.needHelpPendingNotificationId = payload.notificationId;
                }
            },

            handleRefineNotificationShown(notificationId) {
                if (notificationId != null) {
                    this.refinePendingNotificationId = notificationId;
                }
            },

            handleProposalStarted(playbook) {
                this.if_play_generating = true;
                this.currentPlaybookId = playbook?.id ?? null;
                // Route uses playbook.url (UUID), not id
                this.currentPlaybookUrl = (this.client?.url && playbook?.url) ? `/playbooks/${this.client.url}/builder/${playbook.url}` : null;
                this.currentTotalAssets = playbook?.assets?.length ?? 0;
            },

            handlePlaybookCreationModalClose(show) {
                this.showPlaybookCreationModal = show;
            },

            handlePlayGenerating(data) {
                this.if_play_generating = data.generating;
            },

            handleLoadingNavigate(playbook_url) {
                if (!this.client || !this.client.url) {
                    console.error('Client information is missing');
                    return;
                }
                // playbook_url may be just the id/slug (e.g. 1371) or a full path; use only the segment after /builder/
                const segment = String(playbook_url).includes('/builder/')
                    ? String(playbook_url).replace(/^.*\/builder\/?/, '').split('/')[0] || playbook_url
                    : playbook_url;
                router.visit(`/playbooks/${this.client.url}/builder/${segment}`);
            },

            handleCopyPlay(playbook) {
                // Show the copy modal
                this.playbookToCopy = playbook;
                this.showPlaybookCopyModal = true;
            },

            handlePlayDeleted(deletedPlay) {
                // Remove from playbooks array if present (My Plays view)
                if (this.playbooks && this.playbooks.length) {
                    this.playbooks = this.playbooks.filter(p => p.id !== deletedPlay.id);
                }

                // Also remove from local_playbook_types arrays
                this.local_playbook_types = this.local_playbook_types.filter(p => p.id !== deletedPlay.id);
                this.filtered_playbook_types = this.filtered_playbook_types.filter(p => p.id !== deletedPlay.id);

                // Re-paginate
                this.reloadPagination(this.filtered_playbook_types);
            },
        }
    }
</script>
